export default {
    state: {
        search: ''
    },
    getters: {
        publicSearchGlobal: state => state.search
    },
    mutations: {
        SET_SEARCH(state, search) {
            state.search = search
        },
        CLEAR_SEARCH(state) {
            state.search = ''
        }
    },
    actions: {
        setPublicSearchGlobal({ commit }, search) {
            commit('SET_SEARCH', search)
        },
        clearPublicSearchGlobal({ commit }) {
            commit('CLEAR_SEARCH')
        }
    }
}
